import AccountTypeMap from '../../data/enumerators/accountType';

const getAccountType = (status) => (AccountTypeMap.get(+status).description);

export default getAccountType;
